interface IClientProfileInfoCard {
  value: number | string;
  label: string;
  subLabel?: string;
  icon: React.ReactNode;
  valueIcon?: React.ReactNode;
  color: string;
}

const ClientProfileInfoCard = ({
  value,
  label,
  subLabel,
  icon,
  valueIcon,
  color,
}: IClientProfileInfoCard) => {
  // rendering client profile info card component here
  return (
    <div
      style={{ borderColor: color }}
      className={
        'flex flex-col md:flex-row items-center justify-between p-3 shadow-academia-sm border-t-4 md:border-t-0 md:border-l-4 rounded-md gap-3 md:gap-0'
      }
    >
      <div className='flex flex-col md:flex-row items-center justify-between gap-2'>
        <div className='flex items-center justify-center'>{icon}</div>

        <div className='flex flex-col md:flex-row items-center gap-1'>
          <p className='text-lg text-base-dark-blue capitalize'>{label}</p>
          <p className='text-sm md:text-lg font-medium md:font-normal text-base-purple capitalize'>
            {subLabel}
          </p>
        </div>
      </div>

      <div className='flex items-center justify-center gap-1'>
        <div className='flex items-center justify-center'>{valueIcon}</div>
        <h4 style={{ color }} className='font-medium truncate text-2xl'>
          {value}
        </h4>
      </div>
    </div>
  );
};

export default ClientProfileInfoCard;
